import { Form, Formik } from 'formik'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import * as Yup from 'yup'
import Loader from '../../../../components/Loader'
import ModelComponent from '../../../../components/Modal'
import ReactSelect from '../../../../components/ReactSelect'
import { showToast } from '../../../../lib/AllGlobalFunction'
import axiosProvider from '../../../../lib/AxiosProvider'
import { _exception } from '../../../../lib/exceptionMessage'

const AssignTaxRateForm = ({
  modalShow,
  setModalShow,
  initialValues,
  allState,
  loading,
  setLoading,
  fetchData,
  toast,
  setToast
}) => {
  const location = useLocation()
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const validationSchema = Yup.object().shape({
    hsnCodeId: Yup.string()
      .test(
        'nonull',
        'Please select HSN code',
        (value) => value !== 'undefined'
      )
      .required('HSN code required'),
    taxValueId: Yup.string()
      .test(
        'nonull',
        'Please select Tax value',
        (value) => value !== 'undefined'
      )
      .required('Tax value required')
  })

  const onSubmit = async (values, resetForm) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: values?.id ? 'PUT' : 'POST',
        endpoint: 'AssignTaxRateToHSNCode',
        data: values,
        location: location?.pathname,
        userId,
        oldData: initialValues
      })
      setLoading(false)
      if (response?.data?.code === 200) {
        resetForm({ values: '' })
        setModalShow(!modalShow)
        fetchData()
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, setErrors, setTouched, resetForm }) => (
        <Form id='main-hsn-code'>
          <ModelComponent
            show={modalShow}
            modalsize={'md'}
            className='modal-backdrop'
            modeltitle={'Assign tax rate to hsn code'}
            onHide={() => {
              setModalShow(false)
              resetForm({ values: '' })
            }}
            backdrop={'static'}
            formbuttonid={'main-hsn-code'}
            submitname={!initialValues?.id ? 'Create' : 'Update'}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            formik={{ values, setFieldValue, setErrors, setTouched, resetForm }}
          >
            {loading && <Loader />}
            <div className='row'>
              <div className='col-md-12'>
                <div className='input-file-wrapper mb-3'>
                  <label className='form-label required'>Select HSN Code</label>
                  <ReactSelect
                    id='hsnCodeId'
                    name='hsnCodeId'
                    placeholder='Select HSN Code'
                    value={
                      values?.hsnCodeId && {
                        value: values?.hsnCodeId,
                        label: values?.hsnCodeName
                          ? values?.hsnCodeName
                          : values?.hsnCode
                      }
                    }
                    disabled
                    options={
                      allState?.hsnCode &&
                      allState?.hsnCode?.map(({ id, hsnCode }) => ({
                        value: id,
                        label: hsnCode
                      }))
                    }
                    onChange={(e) => {
                      setFieldValue('hsnCodeId', e?.value)
                      setFieldValue('hsnCodeName', e?.label)
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='input-file-wrapper mb-3'>
                  <label className='form-label required'>
                    Select Tax Value
                  </label>
                  <ReactSelect
                    id='taxValueId'
                    name='taxValueId'
                    placeholder='Select Tax Value'
                    options={
                      allState?.taxRate &&
                      allState?.taxRate?.map(({ id, name }) => ({
                        value: id,
                        label: name
                      }))
                    }
                    value={
                      values?.taxValueId && {
                        value: values?.taxValueId,
                        label: values?.taxValueName
                          ? values?.taxValueName
                          : values?.taxName
                      }
                    }
                    disabled
                    onChange={(e) => {
                      setFieldValue('taxValueId', e?.value)
                      setFieldValue('taxValueName', e?.label)
                    }}
                  />
                </div>
              </div>
            </div>
          </ModelComponent>
        </Form>
      )}
    </Formik>
  )
}

export default AssignTaxRateForm
